import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  size?: 'medium' | 'large';
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  variant = 'primary',
  size = 'medium',
  className = ''
}: CTAButtonProps) {
  const baseStyles = 'font-semibold rounded-xl transition-all duration-300 shadow-soft-lg hover:shadow-soft-xl active:scale-95';
  const variantStyles = {
    primary: 'bg-[#C48A47] hover:bg-[#915E2D] text-white',
    secondary: 'bg-[#E8905C] hover:bg-[#D67A45] text-white'
  };
  const sizeStyles = {
    medium: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  };
  return <button onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} data-id="element-43">
      {children}
    </button>;
}